var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: _vm.cols } },
    [
      _c("span", [_vm._v(_vm._s(_vm.title))]),
      _c("quill-editor", {
        ref: "myQuillEditor",
        class: _vm.getErrorClass,
        attrs: {
          content: _vm.content,
          options: _vm.options,
          loading: _vm.loading || _vm.$async.upload.$pending,
          disabled: _vm.disabled,
        },
        on: {
          input: function ($event) {
            return _vm.trim($event)
          },
          change: function ($event) {
            return _vm.onEditorChange($event)
          },
        },
      }),
      _vm.isShowErrorMessage
        ? _c("ErrorMessage", { attrs: { message: _vm.errorText } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }